import {LicenseType} from './LicenseType.enum';

export class AdministratorLicense implements License {
  dateExpired: string;
  id: string;
  isTrial: boolean;
  licenseType: LicenseType;
  licenseDisplayName: string;
  isAutoRenew: boolean;
}


export interface License {
  dateExpired: string;
  id: string;
  isTrial: boolean;
  licenseType: LicenseType;
  isAutoRenew?: boolean;
  licenseDisplayName?: string;
}

export default class LicenseOData {
  Type: LicenseType;
  ExpireDate: Date;
}

export class LicenseTypeSummary {
  type: LicenseType;
  displayName: string;
}

export interface ComputerGrantLicenseResultDTO {
  availableLicenses: LicenseOptionDTO[];
  isAllowBuy: boolean;
  isGranted: boolean;
  license: LicenseInfoDTO | null;
}

export interface LicenseInfoDTO {
  dateActivated: string;
  dateCreated: string;
  dateExpired: string;
  id: string;
  licenseNumber: number;
  licenseType: LicenseType;
}
export interface LicenseOptionDTO {
  count: number;
  licenseType: LicenseType;
}

export interface AvailableLicenses {
  trialLicense: {
    licenseId: string;
    days: number;
  };
  paidLicense: {
    licenseId: string;
    poolName: string;
    validUntil: string;
  };
  newLicensePrice: string;
}

export interface AvailablePaidLicense {
  count: number;
  licenseId: string;
  poolName: string;
  validUntil: string;
  name: string | null
}

export enum ComputerLicenseStatus {
  TRIAL,
  PAID,
  EXPIRED,
  TRIALEXPIRED
}

export interface ComputerLicense {
  id?: string;
  licenseId?: string;
  licenseUsageId?: string;
  licenseType: {
    id: number;
    displayName: string;
  };
  socketsCount: number;
  activated: string;
  validUntil: string;
  autoRenew: boolean;
  licenseKind: number;
  isExpired: boolean;
  isTrial: boolean;
  pool?: ComputerLicensePool
}

export interface ComputerLicensePool {
  "name": 'Company pool' | 'User pool' | "Global pool",
  "subject": {
    "id": string,
    "name": string
  }
}

export interface AvailableLicenseType {
  id: number;
  displayName: string;
  isAllowForCompany: boolean;
}

export type LicenseAssignToAdmin = { adminId: string; license: AdministratorLicense };
export type FilterLicenseAndAdminId = {
  filter: LicenseType[];
  adminID: string;
  expiredCurrent?: boolean;
  email?: string
};
